import request from '@/utils/request'

export const aiChat = params =>
  request.post('/customer-api/customer/ai/ask', params)

export const aiUploadFile = params =>
  request.post('/customer-api/customer/ai/uploadFile', params)

export const getReportList = params =>
  request.post('/customer-api/customer/ai/reportList', params)

export const saveFinancialReport = params =>
  request.post('/customer-api/customer/ai/saveReport', params)

export const getCustomerData = params =>
  request.post('/customer-api/customer/page', params)

export const downloadFile = params =>
  request.get('/customer-api/file/download', params, { responseType: 'blob' })

export const saveToFinancialReport = params =>
  request.post('/customer-api/customer/ai/saveToFinancialReport', params)

export const save = params =>
  request.post('/customer-api/customer/ai/start', params)

export const getCountryRiskReportList = params =>
  request.post('/customer-api/customer/ai/riskReportList', params)

export const saveRiskReport = params =>
  request.post('/customer-api/customer/ai/riskReportStart', params)

export const getCurrencyList = () => request.get('/masterdata-api/rate/list')

export const getCurrenyRate = (date, currencyA) =>
  request.get(`/customer-api/customer/${date}/${currencyA}/to/USD`)

export const duplicateFinancialReport = params =>
  request.post('/customer-api/customer/ai/duplicateFinancialReport', params)

export const getResult = params =>
  request.post('/customer-api/customer/ai/riskReportById', params)

export const getCustomerByName = name =>
  request.get(`/customer-api/customer/list/${name}`)
export const getSubmittedByList = username =>
  request.get(`/masterdata-api/user/active/query/${username}`)
